export function UserAvatar({ name, size = 28 }: { name: string; size?: number }) {
  const initials = (name || '')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-lg border border-sky-200 bg-gradient-to-br from-sky-50 to-blue-100 font-mono font-bold text-sky-700 shadow-2xs select-none"
      style={{ width: size, height: size, fontSize: Math.max(size * 0.38, 10) }}
    >
      {initials || '?'}
    </div>
  )
}
